import { render, staticRenderFns } from "./ClinicianPatientsListTableItem.vue?vue&type=template&id=0c674cfd"
import script from "./ClinicianPatientsListTableItem.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientsListTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports